import { isReadAgreementNotice } from '@/api/marketing';
import { getMemberPopWindow } from '@/api/shopmember';

export default {
  state: {
    // 全局弹窗
    global: null,
    isGlobalLoading: false,
    // 局部会员弹窗
    member: null,
    // 控制是否可以获取会员级弹窗数据
    enableMemberFetch: false,
  },
  actions: {
    // 获取全局弹窗数据
    async fetchGlobalPop({ state }) {
      state.isGlobalLoading = true;
      const { success, data = {} } = await isReadAgreementNotice();
      const { publishDate, isRead } = data;
      state.isGlobalLoading = false;

      // isRead为true表示已同意协议
      if (success && !isRead) {
        state.global = {
          isPricacyShow: true,
          updateTime: publishDate,
        };
      }
    },
    async fetchMemberPop({ state }, types) {
      const { success, data } = await getMemberPopWindow(types);
      if (success) {
        state.member = data;
      }
    },
    resetMemberPop({ state }) {
      state.member = null;
      state.enableMemberFetch = false;
    },
  },
};
